import { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Alert } from '@mui/material'
import QrReader from 'modern-react-qr-reader'

const Scan = () => {

    const navigate = useNavigate()

    const [result,setResult] = useState(null)

    useEffect(() => {
        if(result != null)
            window.open(result,'_blank')
    },[result])

    const isPhone = navigator.share

    return (
        <div style={{ display: 'block',marginTop: 60 }}>
            {isPhone ? <QrReader onScan={result => setResult(result)} onError={error => toast.error('خطایی در پردازش تصویر رخ داده است')} /> : <Alert severity="info" sx={{my: 3}}>این عملیات فقط در موبایل امکان پذیر است</Alert>}
            <div id="services-without-login" onClick={() => navigate('/auth/login')}>
                <i className="fal fa-arrow-left"></i>
            </div>
        </div>
    )
}

export default Scan